export const updateCustomerWithOrder = async (customerId, orderDetails) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/shopify/update-customer-order`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId,
        orderDetails,
      }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to update customer with order details");
  }

  return await response.json();
};
